import React from 'react';
import { Avatar, Dropdown, Menu, Typography } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { FaChevronDown } from 'react-icons/fa';

const { Text } = Typography;

const ProfileMenu = ({ userFullName, userName, list = [] }) => {
    const menu = (
        <Menu>
            {list.map(({ icon, label, onClick }, index) =>
                <Menu.Item key={index} icon={icon} onClick={onClick}>
                    {label}
                </Menu.Item>
            )}

        </Menu>
    );

    return (
        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" className='!bg-white p-2 rounded-xl'  >
            <div className="flex items-center cursor-pointer space-x-2 mr-4">
                <Avatar size="large" icon={<UserOutlined />} />
                <div className="flex-col hidden md:flex">
                    <Text className='' >{userFullName}</Text>
                    <Text className='!text-gray-400' >{userName}</Text>
                </div>
                <FaChevronDown />
            </div>
        </Dropdown>
    );
};

export default ProfileMenu;
